/*global VeloxWebView, moment*/

module.exports = [
    {
        type: "startup", //called on startup
        interceptor: function (app, callback){

            moment.locale(VeloxWebView.i18n.getLang().substring(0,2));
            
            VeloxWebView.i18n.onLanguageChanged(function(lang){
                moment.locale(lang.substring(0,2));
            });

            callback() ;
        }
    }
];